import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

import { DisplayCardProps } from './types';

export const muiStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    root: { borderRadius: '4px 4px 0 0' },
    titleContainer: {
        minHeight: '25px',
        backgroundColor: (props: DisplayCardProps) => {
            if (props.header?.backgroundColor) {
                return props.header.backgroundColor;
            }

            return theme?.app?.clientTheme.colors.primaryColor || '#3C4F70';
        },
        color: (props: DisplayCardProps) => {
            if (props.header?.fontColor) {
                return props.header.fontColor;
            }

            return theme?.app?.applicationColors.enumColors.white || '#FFFFFF';
        },
        borderRadius: '4px 4px 0 0',
        padding: '4px 8px'
    },
    title: {
        fontWeight: 'bold' as const,
        fontSize: '14px',
        lineHeight: '17px',
        textTransform: 'uppercase' as const
    },
    gridContainer: {
        minHeight: (props: DisplayCardProps) => (props.body?.minHeight ?
            `${props.body.minHeight}px`
            : 'auto'),
        width: '100%',
        backgroundColor: (props: DisplayCardProps) => {
            if (props.body?.backgroundColor) {
                return props.body.backgroundColor;
            }

            return theme?.app?.applicationColors.enumColors.white || '#FFFFFF';
        },
        color: (props: DisplayCardProps) => {
            if (props.body?.fontColor) {
                return props.body.fontColor;
            }

            return theme?.app?.applicationColors.fontColor || '#202020';
        },
        padding: '4px 8px'
    }
}));